module.exports = __webpack_public_path__ + "static/media/AE.0a97031c.svg";